import React, { useState } from 'react';

import { WrappedControlProps } from 'app/components/Controls/WrappedControlProps';
import { UtilService } from 'app/services/util.service';
import { containsNonNumeric } from 'app/shared/helpers/containeNonNumeric';

function isValueTooHigh(value: string, max?: number) {
  if (value !== '') {
    const numberValue = +value;

    if (max !== undefined && numberValue > max) {
      return true;
    }
  }

  return false;
}

export function useNumberControl({
  input,
  meta: { touched, valid },
  onClick,
  onControlBlur,
  onValueChange,
  max,
}: WrappedControlProps & {
  min?: number;
  max?: number;
}) {
  const [focused, setFocused] = useState(false);
  const onFocus = () => setFocused(true);
  const error = touched && !valid;
  const isValueCheckVisible = !focused && UtilService.hasValue(input.value);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = event;

    if (containsNonNumeric(value) || isValueTooHigh(value, max)) {
      return;
    }

    input.onChange(value);

    if (onValueChange) {
      onValueChange(value, false, false);
    }
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = event;

    setFocused(false);

    input.onBlur(value);

    if (onControlBlur) {
      onControlBlur();
    }
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return {
    error,
    focused,
    handleBlur,
    handleChange,
    handleClick,
    isValueCheckVisible,
    onFocus,
  };
}
